import { styled } from '@mui/system';
import { Paper, Typography } from '@mui/material';

export const PillPaper = styled(Paper)(({ theme }) => ({
  padding: '18px',
  borderRadius: '23px',
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  backgroundColor: 'background.paper',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '25px',
  [theme.breakpoints.down('md')]: {
    padding: '14px',
    borderRadius: '18px',
    gap: '16px',
    fontSize: '16px',
    lineHeight: '22px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '12px',
    borderRadius: '14px',
    gap: '12px',
    fontSize: '14px',
    lineHeight: '20px',
  },
}));

export const PillText = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  textAlign: 'left',
  whiteSpace: 'pre-line',
  lineHeight: '23px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
  },
}));

